import 'moment';
import 'moment/locale/pl';
import 'fullcalendar';
import 'fullcalendar/dist/locale/pl.js';
import angular from 'angular';
import angularAnimate from 'angular-animate';
import angularAria from 'angular-aria';
import angularMessages from 'angular-messages';
import angularSanitize from 'angular-sanitize';
import angularMaterial from 'angular-material';
import angularLoadingBar from 'angular-loading-bar';
import 'angular-loading-bar/build/loading-bar.css';
import ngMdIcons from 'angular-material-icons';
import ngStorage from 'ngstorage';
import uiRouter from 'angular-ui-router';
import angularMoment from 'angular-moment';
import 'angular-ui-calendar';
import mdDataTable from './md-data-table';
import angularInputMask from './angular-input-masks';
import angularTour from 'angular-ui-tour';
import 'angular-ui-tree';
import 'angular-ui-tree/dist/angular-ui-tree.min.css';
import 'angular-chart.js';

import './scss/md-data-table-style.scss';
import './scss/fullcalendar.scss';
import './scss/custom.scss';

import DialogErrorController from './dialog-error/dialog-error.controller';
import DetailsErrorController from './dialog-error/details-error.controller';
import config from './dependencies.config';

export default angular
  .module('app.dependencies', [
    angularAnimate,
    angularAria,
    angularMessages,
    angularSanitize,
    angularMaterial,
    angularLoadingBar,
    ngMdIcons,
    ngStorage.name,
    uiRouter,
    angularMoment,
    'ui.calendar',
    mdDataTable,
    angularInputMask,
    angularTour,
    'ui.tree',
    'chart.js'
  ])
  .controller('DialogErrorController', DialogErrorController)
  .controller('DetailsErrorController', DetailsErrorController)
  .config(config)
  .name;
